<template>
  <v-container fluid>
    <v-card
      flat
      class="custom-grey-border remove-border-radius"
      :disabled="pageLoading"
    >
      <v-card-title
        class="headline grey lighten-4"
        @click="show_description = !show_description"
      >
        <h3 class="font-weight-700 custom-headline color-custom-blue">
          <v-icon>
            {{ !show_description ? "mdi-chevron-down" : "mdi-chevron-up" }}
          </v-icon>
          Description
        </h3>
      </v-card-title>
      <v-expand-transition>
        <v-card-text v-show="show_description" class="p-6 font-size-16">
          <v-row>
            <v-col cols="6" class="pt-0">
              <label for="trip-description" class="font-weight-700 font-size-16"
                >Trip Description</label
              >
              <editor
                :value="tripDescription"
                @input="(val) => $emit('update:trip-description', val)"
                placeholder="Enter trip description"
              />
            </v-col>
            <v-col cols="6" class="pt-0">
              <label
                for="billing-description"
                class="font-weight-700 font-size-16"
                >Billing Description</label
              >
              <editor
                :value="billingDescription"
                @input="(val) => $emit('update:billing-description', val)"
                placeholder="Enter billing description"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";

export default {
  name: "Description",
  components: {
    editor: TinyMCE,
  },
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    tripDescription: {
      type: String,
      default: "",
    },
    billingDescription: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show_description: true,
    };
  },
};
</script>
